import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth-service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, of } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  let authSrv: AuthService = inject(AuthService);
  let toast: ToastrService = inject(ToastrService);
  let router = inject(Router);

  const existingToken = authSrv.getAccessToken();
  const existingIdCard = authSrv.getUserLogInIdCard();

  const citizen_id = route.queryParams['ID'];
  const currentToken = route.queryParams['token'];
  const system_id = route.queryParams['system_id'];
  
  if (
    (citizen_id && currentToken && system_id) ||
    (existingToken && existingIdCard)
  ) {
    if (currentToken) {
      authSrv.removeAccessParam();
    }

    let updateClientToken = currentToken ? currentToken : existingToken;

    return authSrv
      .userLogin(citizen_id, updateClientToken, system_id, existingIdCard)
      .pipe(
        map((isAuthenticated: boolean) => {
          if (!isAuthenticated) {
            authSrv.removeAccessParam();
            router.navigateByUrl('/unauthorized');
            toast.error('ข้อมูลเข้าระบบไม่ถูกต้อง', 'ขออภัยเกิดข้อผิดพลาด', {
              timeOut: 1500,
              progressBar: true,
            });
          }
          return isAuthenticated;
        }),
        catchError(() => {
          authSrv.removeAccessParam();
          router.navigateByUrl('/unauthorized');
          toast.error('ข้อมูลเข้าระบบไม่ถูกต้อง', 'ขออภัยเกิดข้อผิดพลาด', {
            timeOut: 1500,
            progressBar: true,
          });
          return of(false);
        })
      );
  }

  toast.error('ข้อมูลเข้าระบบไม่ถูกต้อง', 'ขออภัยเกิดข้อผิดพลาด', {
    timeOut: 1500,
    progressBar: true,
  });

  router.navigateByUrl('/unauthorized');
  authSrv.removeAccessParam();

  return of(false);
};
